// This file is autogenerated. Please don't modify it directly. See the README for details
import type ControlIcons from './ControlIcons';

export type ControlIconsSubset = { [icon in ControlIcons]: string };

export const ControlIconsDefinitions: ControlIconsSubset = {
    Accept: '\ue8fb',
    AccessibiltyChecker: '\uf835',
    Accounts: '\ue910',
    Add: '\ue710',
    AddEvent: '\ueeb5',
    AddField: '\ue4c7',
    AddIn: '\uf775',
    AddTo: '\uecc8',
    Airplane: '\ue709',
    AirplaneSolid: '\ueb4c',
    AlarmClock: '\ue919',
    AlertSolid: '\uf331',
    AllApps: '\ue71d',
    Archive: '\uf03f',
    Attach: '\ue723',
    Back: '\ue72b',
    BingLogo: '\ueb6b',
    BirthdayCake: '\uef8d',
    BlockContact: '\ue8f8',
    Blocked: '\ue733',
    Blocked12: '\uf62e',
    BookingsLogo: '\uedc7',
    BoxAdditionSolid: '\uf2d4',
    BoxLogo: '\ued75',
    BoxSubtractSolid: '\uf2d3',
    Broom: '\uea99',
    BulletedList: '\ue8fd',
    Bullseye: '\uf272',
    BullseyeTarget: '\uf5f0',
    Calendar: '\ue787',
    CalendarDay: '\ue8bf',
    CalendarReply: '\ue8f5',
    CalendarSettings: '\uf558',
    CalendarWeek: '\ue8c0',
    CalendarWorkWeek: '\uef51',
    Cancel: '\ue711',
    Car: '\ue804',
    CaretLeftSolid8: '\uedd9',
    CaretRightSolid8: '\uedda',
    CellPhone: '\ue8ea',
    Chat: '\ue901',
    CheckMark: '\ue73e',
    ChevronDown: '\ue70d',
    ChevronDownMed: '\ue972',
    ChevronDownSmall: '\ue96e',
    ChevronLeft: '\ue76b',
    ChevronRight: '\ue76c',
    ChevronRightMed: '\ue974',
    ChevronRightSmall: '\ue970',
    ChevronUp: '\ue70e',
    ChevronUpMed: '\ue971',
    ChevronUpSmall: '\ue96d',
    ChromeClose: '\ue8bb',
    ChromeMinimize: '\ue921',
    CircleAddition: '\uf2e3',
    CircleAdditionSolid: '\uf2e4',
    CircleFill: '\uea3b',
    CircleRing: '\uea3a',
    CityNext: '\uec06',
    Clear: '\ue894',
    ClearNight: '\ue9c2',
    ClearSelection: '\ue8e6',
    ClipboardList: '\uf0e3',
    Clock: '\ue917',
    ClosePane: '\ue89f',
    Cloud: '\ue753',
    CloudAdd: '\ueca9',
    CloudEdit: '\ue4c8',
    CloudUpload: '\uec8e',
    CodeEdit: '\uf544',
    CollapseContent: '\uf165',
    Color: '\ue790',
    Comment: '\ue90a',
    CommentUrgent: '\uf307',
    Completed: '\ue930',
    CompletedSolid: '\uec61',
    Contact: '\ue77b',
    ContactCard: '\ueebd',
    ContactLock: '\uf400',
    Copy: '\ue8c8',
    DateTime: '\uec92',
    DateTime2: '\uea17',
    DeclineCall: '\uf405',
    Delete: '\ue74d',
    DeliveryTruck: '\uebf4',
    DeveloperTools: '\uec7a',
    Diamond: '\ued02',
    Dislike: '\ue8e0',
    Documentation: '\uec17',
    DocumentSearch: '\uef6c',
    Door: '\ueb75',
    DoubleChevronDown: '\uee04',
    DoubleChevronUp: '\uedbd',
    Down: '\ue74b',
    Download: '\ue896',
    Drop: '\ueb42',
    DropboxLogo: '\ued77',
    EaseOfAccess: '\ue776',
    EatDrink: '\ue807',
    Edit: '\ue70f',
    EditNote: '\ued9d',
    EditSolid12: '\uf4b5',
    EgnyteLogo: '\uf373',
    EMI: '\ue731',
    Emoji: '\ue899',
    Emoji2: '\ue76e',
    EmojiTabSymbols: '\ued58',
    Encryption: '\uf69d',
    EndPointSolid: '\ueb4b',
    Error: '\ue783',
    ErrorBadge: '\uea39',
    Event: '\ueca3',
    EventAccepted: '\uf422',
    EventDeclined: '\uf425',
    EventTentative: '\uf423',
    EventToDoLogo: '\uf869',
    ExploreContent: '\ueccd',
    FabricFolder: '\uf0a9',
    FabricMovetoFolder: '\uf0a5',
    FacebookLogo: '\uecb3',
    FangBody: '\ueceb',
    FavoriteList: '\ue728',
    FavoriteStar: '\ue734',
    FavoriteStarFill: '\ue735',
    Fax: '\uef5c',
    Feedback: '\ued15',
    FileASPX: '\uf2e9',
    FileImage: '\uf311',
    Filter: '\ue71c',
    Flag: '\ue7c1',
    Forward: '\ue72a',
    ForwardEvent: '\ued8c',
    Frigid: '\ue9ca',
    FullScreen: '\ue740',
    GIF: '\uf4a9',
    GiftCard: '\ueb8e',
    GlobalNavButton: '\ue700',
    Globe: '\ue774',
    Globe2: '\uf49a',
    GoogleDriveLogo: '\uee0b',
    GotoToday: '\ue8d1',
    GripperDotsVertical: '\uf772',
    Group: '\ue902',
    Heart: '\ueb51',
    HeartBroken: '\uea92',
    HeartFill: '\ueb52',
    Help: '\ue897',
    Hide3: '\uf6ac',
    Highlight: '\ue7e6',
    History: '\ue81c',
    Home: '\ue80f',
    Hotel: '\ue824',
    Important: '\ue8c9',
    Inbox: '\uf41c',
    InboxCheck: '\uef64',
    Info: '\ue946',
    InsertSignatureLine: '\uf677',
    InsertTextBox: '\uec7d',
    Insights: '\ue3af',
    Label: '\ue932',
    Lightbulb: '\uea80',
    LightningBolt: '\ue945',
    Like: '\ue8e1',
    LikeSolid: '\uf3bf',
    Link: '\ue71b',
    Link12: '\uf6e3',
    LinkedInLogo: '\uf20a',
    List: '\uea37',
    Location: '\ue81d',
    LocationDot: '\ue827',
    Lock: '\ue72e',
    Mail: '\ue715',
    MailCheck: '\ued81',
    MailForward: '\ue89c',
    MailOptions: '\uf82c',
    MailPause: '\ued83',
    MailReminder: '\uf418',
    MailSolid: '\uf343',
    MapDirections: '\ue816',
    MapPin: '\ue707',
    MarkAsProtected: '\uf6ae',
    Megaphone: '\ue789',
    MicrosoftTranslatorLogo: '\uf782',
    MiniExpand: '\ue93a',
    MiniExpandMirrored: '\uea5a',
    More: '\ue712',
    MoreSports: '\ueb22',
    MoreVertical: '\uf2bc',
    MSNVideos: '\ueb1c',
    NavigateExternalInline: '\uf35f',
    NewMail: '\uf7ea',
    NotePinned: '\ued9a',
    NumberField: '\uedc4',
    NumberSymbol: '\uf7ac',
    OfficeAddinsLogo: '\ueec7',
    OfficeChat: '\uf70f',
    OneDriveLogo: '\ue941',
    OneNoteLogo: '\uf1e7',
    OpenFile: '\ue8e5',
    OpenInNewTab: '\uf6ab',
    OpenInNewWindow: '\ue8a7',
    OpenPane: '\ue8a0',
    OutlookLogo: '\uf1e9',
    OutlookLogoInverse: '\ueb6d',
    OutlookSpacesBucket: '\ue481',
    OutOfOffice: '\ued34',
    Package: '\ue7b8',
    Page: '\ue7c3',
    PageEdit: '\uefb6',
    PageLink: '\ue302',
    PageRemove: '\uefba',
    PartlyCloudyDay: '\ue9c0',
    PaymentCard: '\ue8c7',
    PDF: '\uea90',
    PencilReply: '\uef7b',
    People: '\ue716',
    PeopleAdd: '\uea15',
    PeopleAlert: '\ued93',
    Phone: '\ue717',
    Photo2: '\ueb9f',
    PhotoBlock: '\ue4c3',
    PieSingle: '\ueb05',
    Pin: '\ue718',
    Pinned: '\ue840',
    PlainText: '\uf834',
    Play: '\ue768',
    POI: '\uecaf',
    Print: '\ue749',
    QRCode: '\ued14',
    Read: '\ue8c3',
    ReceiptReply: '\uef5a',
    Recent: '\ue823',
    Refresh: '\ue72c',
    Remove: '\ue738',
    RemoveContent: '\uecc7',
    RemoveEvent: '\ued8a',
    RemoveLink: '\ued90',
    ReopenPages: '\ued50',
    Reply: '\ue97a',
    ReplyAll: '\uee0a',
    ResponsesMenu: '\uf768',
    RevToggleKey: '\ue845',
    Ribbon: '\ue9d1',
    Ringer: '\uea8f',
    RingerOff: '\uf2c5',
    Save: '\ue74e',
    ScheduleEventAction: '\uf1ef',
    ScrollUpDown: '\uec8f',
    Search: '\ue721',
    SearchCalendar: '\uf4af',
    Send: '\ue724',
    Settings: '\ue713',
    Share: '\ue72d',
    SharedNotes: '\uf481',
    ShowTimeAs: '\uf787',
    SkypeForBusinessLogo: '\uf0fc',
    SkypeForBusinessLogo16: '\uf40f',
    SkypeLogo: '\ueb6f',
    SkypeLogo16: '\uf40e',
    SquareShapeSolid: '\uf63d',
    Stack: '\uf26f',
    StatusCircleCheckmark: '\uf13e',
    StatusCircleErrorX: '\uf13d',
    Stopwatch: '\ue916',
    Sunny: '\ue9bd',
    SyncOccurence: '\uf4a3',
    System: '\ue770',
    Tab: '\ue7e9',
    TabCenter: '\uf100',
    Table: '\ued86',
    Tag: '\ue8ec',
    Taskboard: '\uf1c2',
    TeamsLogo: '\uf27b',
    Telemarketer: '\ue7b9',
    TextDocumentShared: '\uf02b',
    Ticket: '\ueb54',
    ToDoLogoOutline: '\uf75b',
    TVMonitor: '\ue7f4',
    Undo: '\ue7a7',
    Unlock: '\ue785',
    Up: '\ue74a',
    Upload: '\ue898',
    Video: '\ue714',
    VideoAdd: '\ue430',
    View: '\ue890',
    ViewAll: '\ue8a9',
    VoicemailForward: '\ued87',
    VoicemailIRM: '\uf421',
    VoicemailReply: '\ued88',
    Volume2: '\ue994',
    Waffle: '\ued89',
    Warning: '\ue7ba',
    WebPublish: '\uf52f',
    Website: '\ueb41',
    WindowEdit: '\uf50e',
    WipePhone: '\ued8d',
    World: '\ue909',
    WorldClock: '\ue918',
    YammerLogo: '\ued19',
    ZoomIn: '\ue8a3',
    ZoomOut: '\ue71f',
};

const _default_1: {
    fontFileName: string;
    icons: ControlIconsSubset;
} = {
    fontFileName: 'controlIcons',
    icons: ControlIconsDefinitions,
};
export default _default_1;
